module.exports = __webpack_public_path__ + "img/symbol_15_free.6f44cec6.png";